import { ElementRef, Renderer2 } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppChartsService } from '../app-charts/app-charts.service';
import { AbilityReportNewService } from './ability-report-new.service';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { PlatformLocation } from '@angular/common';
var AbilityReportNewComponent = (function () {
    function AbilityReportNewComponent(router, apiService, route, el, render, commonService, platformLocation) {
        this.router = router;
        this.apiService = apiService;
        this.route = route;
        this.el = el;
        this.render = render;
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.chartsType = "radar"; //图表类型
        this.theme = "survey"; //主题
        this.contrast = "Good"; //对比结果
        this.chartKAsData = []; //图表数据
        this.assetsRoute = "../../assets";
        this.returnTxt = "";
        this.currentIndex = 0;
        this.showInfo = true;
        this.isOpenClass = 0;
        this.isSlide = false;
        this.isFirstInPreOrPostTestReport = false; //是否第一次进入报告
        this.isScrollBottom = false; //是否滚到底部
        this.isShowApproachModule = false; //是否显示趋近
        this.isShowShare = false; //是否跳转分享功能
        this.approachLoading = false;
        this.approachTheme = {};
        this.isPC = false;
        this.showPCBtn = false;
        this.isShowBack = false;
        this.isOnlyLearningPathCannotBack = false;
        this.isCustomLock = false; //用户有没有强制锁定
        this.lock = false;
        this.isShowToast = false;
        // Stephen add 2025-03-07 判断是否腾讯对接
        this.isTencent = false;
    }
    AbilityReportNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        // ---Stephen add 2025-03-07---
        // 添加是否腾讯对接的判断
        this.isTencent = this.commonService.checkAndSetModuleId();
        console.log(this.isTencent, '🚆🚆🚆🚆🚆🚆🚆🚆');
        // -------------------------------------------------------------------
        this.subscribeScoll = fromEvent(this.el.nativeElement.querySelector('.abilityReport'), 'scroll').subscribe(function (event) {
            var h = document.documentElement.clientHeight;
            var _h = $('.fillBottom').offset().top;
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (h + scrollTop + 20 > _h) {
                if (!_this.isScrollBottom) {
                    _this.isScrollBottom = false;
                    console.log('到底了');
                }
                _this.isScrollBottom = true;
            }
            else {
                _this.isScrollBottom = false;
            }
            // this.isScrollBottom = h + scrollTop + 20 > _h ? true : false;
        });
        this.projectId = localStorage.getItem("projectId");
        var projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
        if (this.projectId && projectmsg) {
            projectmsg.map(function (item) {
                if (item.type == 2 && item.lockType == 1) {
                    _this.lock = item.lock;
                    _this.promptText = "\u8BFE\u7A0B\u5B66\u4E60\u5C06\u4E8E" + item.promptTime + "\u5F00\u653E\u3002";
                }
            });
        }
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        this.isPC = !!localStorage.getItem('isPC');
        this.isShowBack = this.platformLocation['location']['href'].indexOf('isShowBack') !== -1;
        // this.isOnlyLearningPathCannotBack = !!localStorage.getItem('isOnlyLearningPathCannotBack');
        this.isOnlyLearningPathCannotBack = localStorage.getItem('isOnlyLearningPathCannotBack') || localStorage.getItem('backurl') ? true : false;
        this.showPCBtn = this.isPC;
        this.appChartsService = new AppChartsService();
        this.abilityReportNewService = new AbilityReportNewService(this.apiService);
        this.getApiData();
    };
    AbilityReportNewComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        $('body').addClass('heightAuto');
        var audioEle = this.el.nativeElement.querySelector('#audioPlay');
        this.commonService.initPage();
        this.timer = setTimeout(function () {
            _this.isSlide = false;
            _this.showInfo = false;
            audioEle && _this.render.addClass(audioEle, 'displayNone');
        }, 5000);
        var that = this;
        if (!that.isPC) {
            setTimeout(function () {
                _this.hammertime = new Hammer(document.getElementById('swipeContainer'));
                _this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
                _this.hammertime.on('swipeup swipedown', function (ev) {
                    that.logEventType(ev, that);
                });
            }, 500);
        }
    };
    AbilityReportNewComponent.prototype.ngOnDestroy = function () {
        this.subscribeScoll.unsubscribe();
    };
    AbilityReportNewComponent.prototype.goNext = function () {
        var _this = this;
        $('#swipeContainer').css({
            'top': '-100%',
            'opacity': '0'
        });
        setTimeout(function () {
            $(".abilityReport").css({ 'opacity': '1' });
            $('#swipeContainer').hide();
            _this.slideBtn();
        }, 300);
    };
    AbilityReportNewComponent.prototype.logEventType = function (ev, that) {
        var _this = this;
        if (ev.type == "swipeup") {
            $('#swipeContainer').css({
                'top': '-100%',
                'opacity': '0'
            });
            that.hammertime.get('swipe').set({ enable: false });
            setTimeout(function () {
                $(".abilityReport").css({ 'opacity': '1' });
                $('#swipeContainer').hide();
                _this.slideBtn();
            }, 300);
        }
    };
    //根据type获取数据
    AbilityReportNewComponent.prototype.getApiData = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.learningMetaId = params['learningPathId'];
            _this.surveyStatus = params['typeId'];
            _this.staticDoc = _this.abilityReportNewService.getStaticDoc(_this.surveyStatus);
            _this.abilityReportNewService.getUserIsFirstInPreOrPostTestReport(_this.learningMetaId, _this.surveyStatus).then(function (result) {
                _this.isFirstInPreOrPostTestReport = Number(result.data) === 0 ? true : false;
                _this.approachTheme.isFirst = _this.isFirstInPreOrPostTestReport;
                if (_this.isFirstInPreOrPostTestReport) {
                    _this.abilityReportNewService.saveUserFirstInPreOrPostTestReport(_this.learningMetaId, _this.surveyStatus).then();
                }
            }).then(function () {
                _this.getReport(Number(_this.surveyStatus));
            }).then(function () {
                return _this.commonService.getCustomLockDate(_this.learningMetaId).then(function (result) {
                    return _this.learningPath = result;
                });
            }).then(function () {
                _this.commonService.setCustomLockDate(_this.learningPath, Date());
                _this.isCustomLock = _this.surveyStatus == 1 ? _this.learningPath.subItems[1].isLock : _this.learningPath.subItems[3].isLock;
                console.log(_this.isCustomLock);
            });
        });
    };
    //获取报告
    AbilityReportNewComponent.prototype.getReport = function (surveyStatus) {
        var _this = this;
        if (surveyStatus == 1) {
            localStorage.setItem('moduleId', '1');
            this.pageTitle = "能力诊断报告";
            this.abilityReportNewService.getPreTestReport(this.learningMetaId).then(function (result) {
                _this.report = result;
                _this.learningPathId = _this.report.learningPathId;
                _this.courseId = _this.report.courseId;
                _this.level = _this.report.level ? _this.report.level : 1;
                _this.levelDesc = _this.report.levelDesc;
                _this.courseName = _this.report.courseName;
                _this.teacherName = _this.abilityReportNewService.getTeacherName(_this.courseName);
                _this.setLineChartsData(_this.level);
                _this.suggest = _this.report.b_suggest;
                _this.learningTips = _this.report.learningTips;
                _this.chartKAsData = _this.report.kas ? [_this.report.kas] : [[{ "kaName": "KA1", "kaScore": 10 }, { "kaName": "KA2", "kaScore": 10 }, { "kaName": "KA3", "kaScore": 10 }, { "kaName": "KA4", "kaScore": 10 }, { "kaName": "KA5", "kaScore": 10 }]];
            }).then(function () {
                return _this.getProgress(_this.learningMetaId).then(function (result) {
                    return _this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
                });
            }).then(function () {
                _this.approachTheme.colorSystem = 'dark';
                _this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
                _this.approachTheme.currentIndex = _this.currentIndex - 2;
                _this.approachTheme.desc = '知道了自己的能力画像，是否希望更上层楼？';
                _this.approachTheme.btnTxt = '开启课程学习';
            }).then(function () {
                _this.approachLoading = true;
                //增加学习断点
                _this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(_this.learningMetaId), 'moduleId': 1, 'breakpointUrl': _this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
            });
        }
        else if (surveyStatus == 2) {
            localStorage.setItem('moduleId', '4');
            this.pageTitle = "能力考核报告";
            this.abilityReportNewService.getPostTestReport(this.learningMetaId).then(function (result) {
                _this.report = result;
                _this.courseName = _this.report.courseName;
                // this.returnTxt = {1:"返回公开课",2:"返回体验课"}[Number(localStorage.getItem('companiesType'))]||"完成"+this.courseName;
                _this.contrastSpeech = _this.report.contrastSpeech;
                _this.contrastDesc = _this.report.contrastDesc;
                _this.teacherName = _this.abilityReportNewService.getTeacherName(_this.courseName);
                _this.level = _this.report.b_level && _this.report.a_level ? [_this.report.b_level, _this.report.a_level] : [1, 1];
                _this.setLineChartsData(_this.level);
                _this.a_advantagesKas = _this.report.a_advantagesKas;
                _this.a_shortBoardsKas = _this.report.a_shortBoardsKas;
                _this.shortBoardsFixedSpeech = _this.report.shortBoardsFixedSpeech;
                _this.advantagesFixedSpeech = _this.report.advantagesFixedSpeech;
                _this.fixedSpeech = _this.report.fixedSpeech;
                _this.developmentTipsKas = _this.report.newDevelopmentTipsKas; //新加字段
                // this.developmentTipsKas = this.report.developmentTipsKas;
                _this.developmentTipsFixedSpeech = _this.report.developmentTipsFixedSpeech;
                _this.chartKAsData = _this.report.b_kas && _this.report.a_kas ? [_this.report.b_kas, _this.report.a_kas] : [[{ "kaName": "KA1", "kaScore": 10 }, { "kaName": "KA2", "kaScore": 10 }, { "kaName": "KA3", "kaScore": 10 }, { "kaName": "KA4", "kaScore": 10 }, { "kaName": "KA5", "kaScore": 10 }], [{ "kaName": "KA1", "kaScore": 20 }, { "kaName": "KA2", "kaScore": 20 }, { "kaName": "KA3", "kaScore": 20 }, { "kaName": "KA4", "kaScore": 20 }, { "kaName": "KA5", "kaScore": 20 }]];
            }).then(function () {
                return _this.getProgress(_this.learningMetaId).then(function (result) {
                    return _this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
                });
            }).then(function () {
                if (Number(_this.learningMetaId) > 400 && Number(_this.learningMetaId) < 500) {
                    _this.getLearningTour().then(function (result) {
                        _this.learningTour = result;
                    }).then(function () {
                        // this.apiService.ajax({
                        //   'type': 'GET',
                        //   'url': 'ddilearner/v1/camp/achievement/refresh/'+ this.learningTour.user_id +'/'+localStorage.getItem('skuId')
                        // }).subscribe();
                    });
                }
            }).then(function () {
                _this.approachTheme.colorSystem = 'dark';
                _this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
                // this.approachTheme.currentIndex = 3;
                _this.approachTheme.currentIndex = _this.currentIndex - 2;
                _this.approachTheme.desc = '';
                _this.approachTheme.btnTxt = "完成" + _this.courseName;
                _this.approachLoading = true;
                //增加学习断点
                _this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(_this.learningMetaId), 'moduleId': 4, 'breakpointUrl': _this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
            });
        }
    };
    //获取learningTour
    AbilityReportNewComponent.prototype.getLearningTour = function () {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/v2/learningtournew'
        }).toPromise();
    };
    //获取进度
    AbilityReportNewComponent.prototype.getProgress = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
        }).toPromise();
    };
    // 设置LineCharts（等级对象）
    AbilityReportNewComponent.prototype.setLineChartsData = function (level) {
        if (typeof (level) === "number") {
            var querySelector = this.el.nativeElement.querySelector('#lv' + level);
            this.render.addClass(querySelector, "post");
        }
        else if (typeof (level) === "object" && level.constructor === Array) {
            var classNames = ['pre', 'post'], domFirstName = ".lv";
            for (var i = 0, len = level.length; i < len; i += 1) {
                if (level[i] === level[i + 1]) {
                    classNames = ['eqPre', 'eqPost'];
                    this.contrast = "Normal";
                }
                else if (level[i] < level[i + 1]) {
                    this.contrast = "Good";
                    domFirstName = "#lv";
                }
                else if (level[i] > level[i + 1]) {
                    classNames = ['pre', 'post'];
                    this.contrast = "Bad";
                }
                this.render.addClass(this.el.nativeElement.querySelector(domFirstName + level[i]), classNames[i]);
            }
        }
    };
    // 音频收缩
    AbilityReportNewComponent.prototype.slideBtn = function () {
        var _this = this;
        console.log(this.timer);
        var audioEle = this.el.nativeElement.querySelector('#audioPlay');
        if (this.isSlide) {
            this.showInfo = false;
            this.isSlide = false;
            audioEle && this.render.addClass(audioEle, 'displayNone');
            clearTimeout(this.timer);
        }
        else {
            this.showInfo = true;
            this.isSlide = true;
            audioEle && this.render.removeClass(audioEle, 'displayNone');
            this.timer = setTimeout(function () {
                _this.isSlide = false;
                _this.showInfo = false;
                audioEle && _this.render.addClass(audioEle, 'displayNone');
            }, 5000);
        }
    };
    // 获取课程
    AbilityReportNewComponent.prototype.getCourse = function () {
        if (this.lock) {
            this.showToast();
        }
        else {
            $('body').removeClass('heightAuto');
            this.commonService.learningPortEventLogByCandy({ 'learningPathMetaId': this.learningMetaId, 'module': this.pageTitle, 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem("userId") }).then();
            this.abilityReportNewService.setUserOperationTrack(this.learningMetaId);
            var link = ['course-new', this.learningPathId, this.courseId];
            this.router.navigate(link);
        }
    };
    AbilityReportNewComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    // 完成课程
    AbilityReportNewComponent.prototype.finishCourse = function () {
        var _this = this;
        this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(this.learningMetaId), 'moduleId': -1, 'breakpointUrl': null, 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
        this.commonService.getOnceIno(this.commonService.getOnceValue(this.learningMetaId, 10)).then(function (result) {
            var projectId = localStorage.getItem("projectId");
            if (_this.learningMetaId == 30) {
                if (projectId) {
                    _this.router.navigate(['learning-project', projectId]);
                    return;
                }
                _this.router.navigate(['learning-map']);
            }
            else {
                if (result === 1) {
                    if (localStorage.getItem('skuId') && !localStorage.getItem('onlyCamp')) {
                        _this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId')]);
                    }
                    else if (localStorage.getItem('skuId') && localStorage.getItem('onlyCamp')) {
                        _this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId'), -1]);
                    }
                    else if (!localStorage.getItem('skuId')) {
                        if (projectId) {
                            _this.router.navigate(['learning-project', projectId]);
                            return;
                        }
                        _this.router.navigate(['learning-map']);
                    }
                }
                else {
                    _this.router.navigate(['share', _this.learningMetaId]);
                }
            }
            // let link = this.learningMetaId == 30 ? ['learning-map'] : result === 1 ? ['learning-map'] : ['share', this.learningMetaId];
            $('body').removeClass('heightAuto');
            // this.router.navigate(link);
            _this.commonService.setOnceIno(_this.commonService.getOnceValue(_this.learningMetaId, 10)).subscribe();
        });
    };
    // 关闭
    AbilityReportNewComponent.prototype.close = function () {
        $('body').removeClass('heightAuto');
        // if(this.projectId && this.projectId.trim() != ''){
        //   localStorage.removeItem("projectmsg")
        //   let link = ['learning-project-path', this.learningMetaId];
        //   this.router.navigate(link,{
        // 		queryParams:{
        // 			projectId: this.projectId
        // 		}
        // 	});
        // }else{
        var link = ['learning-path', this.learningMetaId];
        this.router.navigate(link);
        // }
    };
    return AbilityReportNewComponent;
}());
export { AbilityReportNewComponent };



// WEBPACK FOOTER //
// ./src/app/ability-report-new/ability-report-new.component.ts.pre-build-optimizer.js